// src/components/modals/SelectKeyModal.jsx
// Mirrors selkey.asp — the dialog shown when user clicks "Nuevo".
// Lets the user pick document type (Tdo), area (Ger), and privacy/status (Privac).
// If only one option exists for area or privacy, it's hidden (matches ASP behavior).

import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useTexts, TXT } from '../../context/TextContext';

export default function SelectKeyModal({ show, onClose, onConfirm }) {
  const { t } = useTexts();
  const [docTypes, setDocTypes]   = useState([]);
  const [areas, setAreas]         = useState([]);
  const [privacies, setPrivacies] = useState([]);

  const [selectedDocType, setSelectedDocType]   = useState('');
  const [selectedArea, setSelectedArea]         = useState('');
  const [selectedPrivacy, setSelectedPrivacy]   = useState('');

  useEffect(() => {
    if (show) fetchSelectors();
  }, [show]);

  const fetchSelectors = async () => {
    try {
      const [tdoRes, gerRes, priRes] = await Promise.all([
        api.get('/documents/doc-types'),
        api.get('/documents/areas'),
        api.get('/documents/privacies'),
      ]);

      setDocTypes(tdoRes.data);
      setAreas(gerRes.data);
      setPrivacies(priRes.data);

      // Auto-select first values (mirrors ASP idtdoc = 0 -> first from rs)
      if (tdoRes.data.length) setSelectedDocType(String(tdoRes.data[0].Tdo_IdTDoc));
      if (gerRes.data.length) setSelectedArea(String(gerRes.data[0].Ger_IdGer));
      if (priRes.data.length) setSelectedPrivacy(String(priRes.data[0].Pri_IdPrivac));
    } catch (err) {
      console.error('Failed to load selectors:', err);
    }
  };

  const handleConfirm = () => {
    if (!selectedDocType || !selectedArea || !selectedPrivacy) return;
    onConfirm({
      docTypeId: parseInt(selectedDocType),
      areaId:    parseInt(selectedArea),
      privacyId: parseInt(selectedPrivacy),
    });
    onClose();
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t(TXT.NEW_DOCUMENT, 'New document')}</h5>
          </div>

          <div className="modal-body">
            <div className="col-sm-12">
              <div className="container">

                {/* Document Type - always shown */}
                <div className="row campo" style={{ borderBottom: '1px solid' }}>
                  <div className="col-sm-6 mb-2">{t(TXT.DOC_TYPE_LABEL, 'Document type')}:</div>
                  <div className="col-sm-6 mb-2 valor">
                    <select
                      className="campo_fino"
                      style={{ width: '100%', border: 'none', outline: 'none' }}
                      value={selectedDocType}
                      onChange={(e) => setSelectedDocType(e.target.value)}
                    >
                      {docTypes.map((t) => (
                        <option key={t.Tdo_IdTDoc} value={t.Tdo_IdTDoc}>
                          {t.Tdo_NombTDoc}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Area - only shown if more than one option (mirrors ASP cantger > 1) */}
                {areas.length > 1 && (
                  <div className="row campo" style={{ borderBottom: '1px solid' }}>
                    <div className="col-sm-6 mb-2">{t(TXT.AREA_LABEL, 'Area')}:</div>
                    <div className="col-sm-6 mb-2 valor">
                      <select
                        className="campo_fino"
                        style={{ width: '100%', border: 'none', outline: 'none' }}
                        value={selectedArea}
                        onChange={(e) => setSelectedArea(e.target.value)}
                      >
                        {areas.map((g) => (
                          <option key={g.Ger_IdGer} value={g.Ger_IdGer}>
                            {g.Ger_DesGer}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* Privacy / Status - only shown if more than one option */}
                {privacies.length > 1 && (
                  <div className="row campo" style={{ borderBottom: '1px solid' }}>
                    <div className="col-sm-6 mb-2">{t(TXT.STATUS_LABEL, 'Status')}:</div>
                    <div className="col-sm-6 mb-2 valor">
                      <select
                        className="campo_fino"
                        style={{ width: '100%', border: 'none', outline: 'none' }}
                        value={selectedPrivacy}
                        onChange={(e) => setSelectedPrivacy(e.target.value)}
                      >
                        {privacies.map((p) => (
                          <option key={p.Pri_IdPrivac} value={p.Pri_IdPrivac}>
                            {p.Pri_DesPrivac}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="button" onClick={onClose}>{t(TXT.CANCEL, 'Cancel')}</button>
            <button type="button" className="button color1" onClick={handleConfirm}>{t(TXT.CONFIRM, 'Confirm')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
